import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { CalendarConnectionStatus, CalendarMetadataDto } from './types/calendar.types';

export const useCalendarStore = defineStore('calendar', () => {
  const connectionStatus = ref<CalendarConnectionStatus | null>(null);
  const connectionFlowActive = ref(false);
  const currentUserNeedsUpgrade = ref(false);
  const calendarConnectionOauthUrl = ref<string | null>(null);
  const calendars = ref<CalendarMetadataDto[]>([]);
  const defaultCalendarId = ref<string | undefined>(undefined);

  // alphabetized list
  return {
    calendarConnectionOauthUrl,
    calendars,
    connectionFlowActive,
    connectionStatus,
    currentUserNeedsUpgrade,
    defaultCalendarId,
  };
});
